import { getIn, useFormikContext } from "formik";
import { useContext, useEffect, useState } from "react";
import FormikControlContext from "../../../Contexts/FormikControlContext";
import renderOptionComponent from "./AutoCompleteFieldHelper/renderOptionComponent";
import handleRelianceIPAInputChangeHelper from "./AutoCompleteFieldHelper/relianceIPAHelper/handleRelianceIPAInputChangeHelper";
import handleRelianceIPAOptionSelectHelper from "./AutoCompleteFieldHelper/relianceIPAHelper/handleRelianceIPAOptionSelectHelper";
import getRelianceIPAOptionLabelHelper from "./AutoCompleteFieldHelper/relianceIPAHelper/getRelianceIPAOptionLabelHelper";

export default function useAutoCompleteField() {
  // const { selectedValue, setSelectedValue } = useContext(AutoCompleteContext);
  // console.log("selectedValue: ", selectedValue);
  const field = useContext(FormikControlContext);
  const { name, productName } = field;

  const formik = useFormikContext();

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const value = getIn(formik.values, name);
  // console.log(name, value);

  const [selectedValue, setSelectedValue] = useState(value);
  // console.log(name, getIn(formik.values, name));

  // -----------Start--------------------
  // This all logic is for showing selected option in the field

  const { setFieldValue } = formik;
  const f_name = name?.split(".")[0]; // taking parent objectkey

  useEffect(() => {
    // Temporary logic, should be removed later
    // console.log("autofieldname_", f_name);
    setFieldValue(`${f_name}.auto_field_key`, f_name[0]);
  }, []);
  // ------------End---------------------

  const handleInputChange = (event, value) => {
    if (!value) return;

    // Handle input change product wise
    if (productName === "Reliance IPA") {
      handleRelianceIPAInputChangeHelper(
        event,
        setOptions,
        setLoading,
        formik,
        name
      );
    }
  };

  const handleOptionSelect = (event, option) => {
    // console.log("option: ", option);
    if (!option) return;
    setSelectedValue(option);

    // Handle input change product wise
    if (productName === "Reliance IPA") {
      handleRelianceIPAOptionSelectHelper(
        event,
        name,
        option,
        setSelectedValue,
        formik
      );
    }
  };

  const getOptionLabel = (option) => {
    // Handle input change product wise
    if (productName === "Reliance IPA") {
      return getRelianceIPAOptionLabelHelper(option, formik, name);
    }

    return option.toString();
  };

  const renderOption = (props, option) => {
    return renderOptionComponent(props, option, productName);
  };

  return {
    options,
    selectedValue,
    loading,
    handleOptionSelect,
    handleInputChange,
    getOptionLabel,
    renderOption,
  };
}
